const PlaylistTracksService = {

  store(playlistId, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`playlists/${playlistId}/tracks`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  update(playlistId, payload) {
    return new Promise((resolve, reject) => {
      axios.patch(`playlists/${playlistId}/tracks`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  sync(playlistId, payload) {
    return new Promise((resolve, reject) => {
      axios.patch(`playlists/${playlistId}/tracks/synchronize`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  destroy(playlistId, track) {
    return new Promise((resolve, reject) => {
      axios.delete(`playlists/${playlistId}/tracks`, { data: track })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

};

export default PlaylistTracksService;
